<template>
  <div class="row no-wrap">
    <default-checkbox :value="agreeToTermsAndConditions" v-on="$listeners" >
      <div class="riseup-terms-and-conditions">
        <span>אני מאשר.ת את </span>
        <span class="r-link-button" @click.stop="openTermsAndConditions">תנאי השימוש</span>
        <span>&nbsp;</span>
        <span class="r-link-button" @click.stop="openPrivacyPolicy">ומדיניות הפרטיות</span>
        <span> של riseup</span>
      </div>
    </default-checkbox>
  </div>
</template>

<script>
import DefaultCheckbox from '@/components/styled/DefaultCheckbox';
import ExternalPagesActions from '@/mixins/ExternalPagesActions';

export default {
  name: 'AgreeTermsAndConditions',
  components: { DefaultCheckbox },
  mixins: [ExternalPagesActions],
  props: {
    agreeToTermsAndConditions: Boolean,
  },
};
</script>
